import { styled as r, rootShouldForwardProp as t } from "@tino-frontend/coreui";
import { SvgIcon as l } from "@tino-frontend/icons";
const d = r(l, {
  shouldForwardProp: (o) => t(o) || o === "classes",
  name: "TrueSvgLogo",
  slot: "Root"
})(({ height: o = 24 }) => ({
  width: "auto !important",
  height: `${o}`.includes("px") ? o : `${o}px`,
  fill: "none"
}));
export {
  d as SvgIconRoot
};
//# sourceMappingURL=svg-icon.styles.js.map
